import gsap from "gsap";

let parent = document.querySelector(".collab-animation");
import { reverse } from "svg-path-reverse";
class Collaboration {
  constructor() {
    this.collabcircles = [
      ...document.querySelectorAll(".collab-animation__circleicon"),
    ];

    this.collabArrows = [
      ...document.querySelectorAll(".collab-animation__arrow"),
    ];

    this.elsToAnimate = [];

    this.collabcircles.forEach((circle, index) => {
      let text = circle.getAttribute("data-text");
      this.createCircle(circle, text);
    });
    if (!window.isMobile) {
      this.createTimeline();
    } else {
      this.createTimeline(true);
    }
    // this.thePath = document.querySelector(".thePath");
    // this.createCircle(this.collabcircles[0],'first')
  }

  createCircle(dom, text) {
    text = text.toUpperCase();
    console.log(dom, text, this.thePath);

    let currentPath = dom.querySelector(".svgpath");
    let currentTextPath = dom.querySelector(".svgtextpath");
    let currentSVG = dom.querySelector("svg");
    let currentSVGText = dom.querySelector(".svgtext");

    let w = dom.clientWidth;
    let margin = w * 0.01;
    currentSVG.setAttributeNS(null, "viewBox", `0 0 ${w}  ${w}`);
    let d = `M${margin},${w / 2}A${(5 * w) / 10 - margin},${
      (5 * w) / 10 - margin
    } 0 0 0 ${w - margin} ${(5 * w) / 10} A${(5 * w) / 10 - margin},${
      (5 * w) / 10 - margin
    } 0 0 0 ${margin} ${(5 * w) / 10}`;
    d = reverse(d);

    currentPath.setAttributeNS(null, "d", d);
    let len = currentPath.getTotalLength();
    console.log(len);
    let finalText = "";
    let koef = 1;
    if (text.length > 5) {
      koef = 0.8;
    }
    for (let i = 0; i < 190 * koef; i += text.length) {
      finalText += text + " ";
    }
    currentTextPath.innerHTML = finalText;
    currentTextPath.setAttributeNS(null, "textLength", len - 5);
    if (window.isMobile)
      currentTextPath.setAttributeNS(null, "textLength", len - 5);

    this.elsToAnimate.push({
      dom,
      svg: currentSVG,
      text: currentSVGText,
    });
  }

  createTimeline(flag) {
    if (!flag) {
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".collab-animation",
          start: "top 20%",
          end: "+=3000",
          scrub: true,
          pin: true,
        },
      });
    } else {
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".collab-animation",
          start: "top 20%",
          end: "bottom 100%",
          scrub: true,
          // pin: true,
        },
      });
    }

    this.tl.to(this.elsToAnimate[0].text, {
      fill: "#e9fed2",
      duration: 1,
      ease: "none",
    });
    this.tl.fromTo(
      this.elsToAnimate[0].svg,
      {
        rotation: 0,
      },
      {
        rotation: 60,
        duration: 1,
        ease: "none",
        onComplete: ()=>{
          this.collabArrows[0].classList.add('is-active')
        }
      }
    );

    this.tl.to(this.elsToAnimate[1].text, {
      fill: "#e9fed2",
      duration: 1,
      ease: "none",
      
    });

    

    this.tl.fromTo(
      this.elsToAnimate[1].svg,
      {
        rotation: 0,
      },
      {
        rotation: 60,
        duration: 1,
        ease: "none",
        onComplete: ()=>{
          this.collabArrows[1].classList.add('is-active')
        }
      }
    );

    this.tl.to(this.elsToAnimate[2].text, {
      fill: "#e9fed2",
      duration: 1,
      ease: "none",
    });

    this.tl.fromTo(
      this.elsToAnimate[2].svg,
      {
        rotation: 0,
      },
      {
        rotation: 60,
        duration: 1,
        ease: "none",
      }
    );
  }
}

if (parent) new Collaboration();
